import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import TextBlock from "../components/textBlock"
import Carousel from "../components/carousel"
import Item from "../components/item"
import Section from "../components/section"

import HeroPNG from "../images/technology/ml_hero_platform.png"
import HeroBackgroundJPG from "../images/technology/ML_hero-technology.jpg"
import CloudCoureSVG from "../images/technology/cloud-core.svg"
import ComplianceSVG from "../images/technology/compliance.svg"
import DisruptiveThinkingSVG from "../images/technology/disruptive_thinking.svg"
import MigrateScaleSVG from "../images/technology/migrate_scale.svg"
import SavingSmallSVG from "../images/technology/savings_small.svg"
import WorkAnywhereSVG from "../images/technology/work-anywhere.svg"
import WorldSVG from "../images/technology/world.svg"

import AdyenSVG from "../images/technology/logos/adyen.svg"
import AmazonSVG from "../images/technology/logos/amazon_workspaces.svg"
import AwsSVG from "../images/technology/logos/aws.svg"
import CalabriologoSVG from "../images/technology/logos/calabriologo.svg"
import CapitaSVG from "../images/technology/logos/capita.svg"
import CitrixSVG from "../images/technology/logos/citrix.svg"
import GammaSVG from "../images/technology/logos/gamma.svg"
import GoogleCloudSVG from "../images/technology/logos/google_cloud.svg"
import IbmSVG from "../images/technology/logos/IBM.svg"
import JabraSVG from "../images/technology/logos/jabra.svg"
import ManxSVG from "../images/technology/logos/manx.svg"
import MicrosoftSVG from "../images/technology/logos/microsoft.svg"
import SalesForceSVG from "../images/technology/logos/salesforce.svg"
import SapSVG from "../images/technology/logos/sap.svg"
import ThreeSVG from "../images/technology/logos/three.svg"
import awscentric from "../images/technology/app-centric.svg"

const logos = [
  AwsSVG,
  AdyenSVG,
  CitrixSVG,
  CapitaSVG,
  ThreeSVG,
  SalesForceSVG,
  AmazonSVG,
  JabraSVG,
  IbmSVG,
  MicrosoftSVG,
  ManxSVG,
  GoogleCloudSVG,
  CalabriologoSVG,
  SapSVG,
]

const carouselData = [
  {
    title: 'Platform <span class="highlight">Technology.</span>',
    subtitle:
      "Our technology platform which has been lovingly engineered since our inception in 2016.",
    image: HeroPNG,
    theme: "theme-green",
    backgroundImage: HeroBackgroundJPG,
  },
]

const itemsData = [
  {
    name: "Cloud Core.",
    image: CloudCoureSVG,
    description:
      "Cloud technology enables us to innovate and scale much faster.",
  },
  {
    name: "Anywhere Workers.",
    image: WorkAnywhereSVG,
    description:
      "Users expect services to be modern and relevant to how they live and work.",
  },
  {
    name: "App Centric.",
    image: awscentric,
    description:
      "Our first thought is always building experiences in modern day Apps.",
  },
  {
    name: "Intelligence.",
    image: DisruptiveThinkingSVG,
    description:
      "Build solutions to be intelligent enough to learn how users behave.",
  },
  {
    name: "Global Scale.",
    image: WorldSVG,
    description:
      "We want to build products that are globally scalable with ease.",
  },
  {
    name: "Unbundling Costs.",
    image: SavingSmallSVG,
    description: "We want to be affordable and adopt new pricing methods.",
  },
]

const Integrations = () => (
  <Layout theme="integrations">
    <SEO
      title="Our Technology - Bridging The Gap Between Modern & Legacy Communication Solutions"
      description="Our super-modern cloud software stack powers digital customer experience communication through a scalable, secure and flexible platform that we own and control."
      keywords="mission labs products, circleloop, smartagent, smartpci, agent desktop, agent desktop for amazon connect, omnichannel desktop, digital customer experience, ai, artificial intelligence, natural language processing, amazon connect, amazon lex, amazon polly, cloud communications, business phone system, pbx replacement, cloud based phone system, omnichannel cloud, uk technology companies, cloud communications, cloud phone provider, manchester tech, tech startup, mobile technology, app development, software companies, tech startup manchester, tech company lancashire, manchester digital, aws partner"
      robots="index, follow"
      revisit_after="1 month"
    />
    <Carousel data={carouselData} />
    <TextBlock
      contrast
      title="  <span>Bridging the gap between <br></span> legacy and modern day systems."
    >
      <p>
        Architected from the ground up to bridge the gap between legacy
        providers and modern-day digital communication experience. We’ve built
        our platform as a super modern software stack which, unlike other
        providers, we own and control. The roll-out of new features is achieved
        in hours and days, rather than weeks and months. This gives us great
        flexibility to react to changes in the market and deliver to customer
        demands. Our Platform contains our unique intellectual property that we
        will continue to protect as development progresses and we grow our
        business.
      </p>
    </TextBlock>

    <section className="section section--center inverse section-padding">
      <h2>Our principles.</h2>
      <hr />
      <div className="centre items items--center">
        {itemsData.map((props, idx) => (
          <Item key={idx} {...props} />
        ))}
      </div>
    </section>

    <Section title={"Scalability."} image={MigrateScaleSVG} padded>
      Our cloud infrastructure is secure and scales very quickly and
      efficiently. Not constrained by hardware, we can operate globally which
      will allow us to grow with you and your business internationally in the
      future: handling multiple telecoms carriers, languages and payments with
      ease. Application frameworks we have developed talk to our platform giving
      access to all our solutions and their market leading features.
    </Section>
    <Section title={"Security."} reverse image={ComplianceSVG} padded>
      Our platform sits within the Amazon Web Services (AWS) public cloud,
      providing unlimited scale and a PCI Level 1 and ISO 27001 secure
      environment.
    </Section>

    <section className="section--center inverse theme-green">
      <div className="centre section-padding">
        <div>
          <h2>Our Partners.</h2>
          <hr />
        </div>
        <div className="partner-grid">
          {logos.map((icon, idx) => (
            <div key={idx}>
              <img src={icon} alt="" />
            </div>
          ))}
        </div>
      </div>
    </section>
  </Layout>
)

export default Integrations
